// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"1ed64d21","251":"0ae10602","358":"70928724","538":"16f7efe0","555":"4479382f","652":"5d428c30","782":"8fd7696b","860":"91532e06"}[chunkId] + ".css";
};